module.exports = __webpack_public_path__ + "img/Research-Development.f023185f.png";